import { makeStyles } from '@material-ui/core';

export const cmpStyle = makeStyles((theme) => ({
  root: {
    maxWidth: '400px',
    margin: 'auto',
  },

  boxImage: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(5),
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
}));
